<template>
  <div>

  </div>
</template>

<script>
export default {
name: "SingleUpdate",

}
</script>

<style scoped>

</style>